const { eventConstants } = require('./eventConstants')

exports.zapier = {
	eventConstants,
}
